// Please put date in YYYY-MM-DD format
export const otherPhotos = [
    {
        name: "Brooklyn Bridge Park",
        desc: "From left to right: Maggie, Justin, Khandy, Wentao, Corinne",
        date: "2018-06-01",
    	imgname: "brooklynbridge-0.png",
    	credits: "Khandy",
    },
    {
        name: "Fire Poi",
        desc: "An exposure of fire poi. I think that's Glib.",
        date: "2019-06-01",
    	imgname: "fire_exposure0.png",
    	credits: "Khandy",
    },
    {
        name: "Fire Poi",
        desc: "An exposure of fire poi. I think that's Glib.",
        date: "2019-06-10",
    	imgname: "fire_exposure1.png",
    	credits: "Khandy",
    },
    {
        name: "Frontal Flowers",
        desc: "Exposure of frontal flowers.",
        date: "2019-06-01",
    	imgname: "flower_exposure0.png",
    	credits: "Khandy",
    },
    {
        name: "Four Petal Antispin Flowers",
        desc: "Exposure of four petal antispin flowers.",
        date: "2019-06-10",
    	imgname: "flower_exposure1.png",
    	credits: "Khandy",
    },
    {
        name: "Four Petal Antispin Flowers",
        desc: "Exposure of four petal antispin flowers. Probably Matthew.",
        date: "2019-06-10",
    	imgname: "flower_exposure2.png",
    	credits: "Khandy",
    },
    {
        name: "Antispin Flowers",
        desc: "Exposure of antispin flowers.",
        date: "2019-06-10",
    	imgname: "flower_exposure3.png",
    	credits: "Khandy",
    },
    {
        name: "<3",
        desc: "Heart exposure.",
        date: "2019-06-01",
    	imgname: "heart_exposure.png",
    	credits: "Khandy",
    },
    {
        name: "<3",
        desc: "Heart exposure.",
        date: "2019-06-10",
    	imgname: "heart_exposure1.png",
    	credits: "Khandy",
    },
    {
        name: "Bowtie",
        desc: "Heiley doing a bowtie orbital.",
        date: "2018-08-01",
    	imgname: "bowtie.png",
    	credits: "Khandy",
    },
    {
        name: "Flip-Flop",
        desc: "Vivian H.",
        date: "2020-01-01",
    	imgname: "some_exposure.png",
    	credits: "Khandy",
    },
    {
        name: "Circle",
        desc: "An exposure of someone doing a circle.",
        date: "2018-06-01",
    	imgname: "some_exposure1.png",
    	credits: "Khandy",
    },
    {
        name: "Circle",
        desc: "An exposure of someone doing a circle.",
        date: "2018-06-01",
    	imgname: "some_exposure2.png",
    	credits: "Khandy",
    },
    {
        name: "Spirals",
        desc: "Finally, a move Alice can recognize. Probably Matthew.",
        date: "2019-06-01",
    	imgname: "spiral_exposure0.png",
    	credits: "Khandy",
    },
    {
        name: "Star",
        desc: "Star exposure.",
        date: "2018-06-01",
    	imgname: "star_exposure.png",
    	credits: "Khandy",
    },
    {
        name: "Random",
        desc: "A random exposure.",
        date: "2018-06-31",
    	imgname: "random_exposure.png",
    	credits: "Khandy",
    },
    {
        name: "Random",
        desc: "A random exposure. Jason points out it might be a failed attempt at words.",
        date: "2018-06-31",
    	imgname: "random_exposure1.png",
    	credits: "Khandy",
    },
    {
        name: "Whip Light",
        desc: "Exposure taken of a whip light.",
        date: "2018-06-31",
    	imgname: "whip_exposure0.png",
    	credits: "Khandy",
    },
    {
        name: "FlowVid-19",
        desc: "Our StuySquad performance for FlowVid-19!",
        date: "2020-06-10",
    	imgname: "flowvid-19.png",
    	credits: "Khandy",
    },
    {
        name: "Handy Dandy Steve Guide",
        desc: "Masterpiece by Vivian Y. Handy dandy for knowing how to space yourself on stage.",
        date: "2018-06-31",
    	imgname: "steve_guide.png",
    	credits: "Vivian Y.",
    },
    {
        name: "Goodbye Shiho",
        desc: "Goodbye studio for tiniest flower Shiho.",
        date: "2019-07-05",
    	imgname: "studio-07052019.png",
    	credits: "Khandy",
    },
    {
        name: "Big Sib Little Sib Dance",
        desc: "Khandy and Corinne with Hong and Terren.",
        date: "2019-10-05",
    	imgname: "bigsib-littlesib-dance.png",
    	credits: "Khandy",
    },
    {
        name: "Flow Bulbasaur",
        desc: "The StuyFlow bulbasaur. Actually it's Steve's.",
        date: "2019-12-25",
    	imgname: "bulbasaur.png",
    	credits: "Steve",
    },
    {
        name: "Glowstick",
        desc: "StuyFlow's glowsticks light the way.",
        date: "2019-10-05",
    	imgname: "glowstick-0.png",
    	credits: "pls let me know i pulled this from the gc",
    },
    {
        name: "Hi",
        desc: "Exposure of a hi",
        date: "2018-3-05",
    	imgname: "hi.png",
    	credits: "Khandy",
    },
    {
        name: "Join Senior SING!",
        desc: "Join Senior SING! Flow",
        date: "2018-3-05",
    	imgname: "join-senior-flow.png",
    	credits: "who knows",
    },
    {
        name: "Cool Whips",
        desc: "Nice picture of Khandy with the whip.",
        date: "2020-3-05",
    	imgname: "khandy_whip_3.png",
    	credits: "Khandy",
    },
    {
        name: "Cool Whips",
        desc: "Nice picture of Khandy with the whip.",
        date: "2020-3-05",
    	imgname: "khandy_whip_4.png",
    	credits: "Khandy",
    },
    {
        name: "Cool Whips",
        desc: "Nice picture of Khandy with the whip.",
        date: "2020-3-05",
    	imgname: "khandy_whip_5.png",
    	credits: "Khandy",
    },
    {
        name: "Raymond",
        desc: "Hi my name is Raymond and you are watching Disney Channel.",
        date: "2019-3-05",
    	imgname: "raymond.png",
    	credits: "let me knowww",
    },
    {
        name: "Show",
        desc: "Cool exposure of a show, let me know which one if you recognize it.",
        date: "2017-3-05",
    	imgname: "some_show_0.png",
    	credits: "lmk",
    },
    {
        name: "Show",
        desc: "Cool exposure of a show, let me know which one if you recognize it.",
        date: "2017-3-05",
    	imgname: "some_show_1.png",
    	credits: "lmk",
    },
    {
        name: "Show",
        desc: "Cool exposure of a show, let me know which one if you recognize it.",
        date: "2017-3-05",
    	imgname: "some_show_3.png",
    	credits: "lmk",
    },
    {
        name: "Show",
        desc: "Cool exposure of a show, let me know which one if you recognize it.",
        date: "2017-3-05",
    	imgname: "some_show_4.png",
    	credits: "lmk",
    },
    {
        name: "Show",
        desc: "Cool exposure of a show, let me know which one if you recognize it.",
        date: "2017-3-05",
    	imgname: "some_show_5.png",
    	credits: "lmk",
    },
    {
        name: "Circles",
        desc: "Exposure of circles. Is Kevin.",
        date: "2019-11-05",
    	imgname: "staff_exposure0.png",
    	credits: "Maggie",
    },
    {
        name: "Circles",
        desc: "Exposure of circles. Is Kevin.",
        date: "2019-11-05",
    	imgname: "staff_exposure1.png",
    	credits: "Maggie",
    },
    {
        name: "Antispin",
        desc: "Exposure of antispin on staff. Is Kevin. I suck at naming moves.",
        date: "2019-11-05",
    	imgname: "staff_exposure2.png",
    	credits: "Maggie",
    },
    {
        name: "Khandy feat. Viviyan",
        desc: "Too good to not include, edits to Khandy?",
        date: "2019-06-08",
    	imgname: "vivian.png",
    	credits: "Vivian is Sam, rest is Khandy",
    },

]
